// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","FooterText":"Footer_FooterText__rcYxs","FooterRight":"Footer_FooterRight__QvXDv"};